import { ToolkitCode } from '@itk/types';

export interface SearchConditionRequest {
  name: string;
  toolkit: ToolkitCode;
}

export interface SearchDrugRequest {
  name: string;
  toolkit: ToolkitCode;
}

export interface SearchHospitalizationRequest {
  name?: string;
  toolkit: ToolkitCode;
}

export interface QuestionnaireRequest {
  name: string;
  is_drug: boolean;
  toolkit: ToolkitCode;
  session_id?: string;
  action: 'get' | 'init' | 'answer' | 'previous' | 'edit';
  answer: string[] | undefined;
}

export interface DoubleDateAnswer {
  answer1: string;
  answer2: string;
}

export interface QuestionnairePreviousAnswer {
  text: string;
  text2: string;
  type: string;
  type2: string;
  catch_all: boolean;
  input_type: string;
  name: string;
  answer: string | DoubleDateAnswer;
  question_id: number;
  section_id: number;
  questionIndex: number;
}

export interface RadioQuestion {
  text: string;
  type: string;
  options: string[];
  catch_all: boolean;
  input_type: string;
}

export interface DoubleDateQuestion {
  text: string;
  type: string;
  text2: string;
  type2: string;
  input_type: string;
  currently_text: string;
  currently_checkbox: boolean;
}

export interface QuestionType extends RadioQuestion, DoubleDateQuestion {}

export interface QuestionnaireResponse {
  is_last_question: boolean;
  has_next: boolean;
  has_prev: boolean;
  answer: string[] | undefined | null;
  underwriting_items: UnderwritingItemAnswer[];
  name: string;
  is_drug: boolean;
  hospitalization: boolean;
  hospitalization_reason: string;
  auto_added: boolean;
  question?: QuestionType;
  session_id: string;
  linked_session_id?: string;
  is_hospitalization_reason: boolean;
}

export interface UnderwritingItemAnswer {
  type: string;
  question: string;
  answer: string;
  question_id: number;
  section_id: number;
}

// This gets sent to the UW api for underwriting
export interface UnderwritingItem {
  sessionId: string;
  hasNext: boolean;
  hasPrev: boolean;
  question?: QuestionType;
  linkedSessionId?: string;
  isHospitalizationReason: boolean;
  answer: string[] | undefined | null;
  name: string;
  isDrug: boolean;
  answers: UnderwritingItemAnswer[];
  type: 'Health Condition' | 'Drug';
  autoAdded: boolean;
  hospitalization: boolean;
  hospitalizationReason: string | null | undefined;
  isLastQuestion: boolean;
}

export function questionnaireToUnderwritingItem(
  x: QuestionnaireResponse,
): UnderwritingItem {
  return {
    sessionId: x.session_id,
    hasNext: x.has_next,
    hasPrev: x.has_prev,
    question: x.question,
    linkedSessionId: x.linked_session_id,
    isHospitalizationReason: x.is_hospitalization_reason,
    answer: x.answer,
    name: x.name,
    isDrug: x.is_drug,
    answers: x.underwriting_items,
    type: x.is_drug ? 'Health Condition' : 'Drug',
    autoAdded: x.auto_added,
    hospitalization: x.hospitalization,
    hospitalizationReason: x.hospitalization_reason,
    isLastQuestion: x.is_last_question,
  };
}
